<template>
  <div v-if="!isLoading && hasData" class="my-type-top">
    <div class="my-type-ico">
      <component :is="typeImage"></component>
    </div>
    <div class="my-type-text-wrap">
      <p class="my-type-tit"><span>{{ data.type }}</span>타입이네요</p>
      <p class="my-type-text01">
        {{ data.analysisdate }}부터 어제까지
        <template v-if="showThreeMonth">
          3개월간
        </template>
        이용하신 총 {{ data.vodviewtime }}시간의 이용내역을 바탕으로 분석한 내용이예요.</p>
    </div>
  </div>
  <div v-else-if="!isLoading && !hasData">
    <div class="no-pooq">
      <p v-if="data && data.joindate !== undefined"><span>{{data.joindate}}</span> 가입 후</p>
      <p>웨이브와 함께 한 시간이 없네요.</p>
    </div>
    <div class="component-wrap">
      <div class="my-pooq-noti">
        <p><span>한 편이라도 5분 이상 시청하면</span><br>다음날 바로 분석 결과를 확인 할 수 있어요!</p>
        <p>시청 시간이 늘어날수록 드러나는<br> <span>나만의 취향을</span> 확인해보세요.</p>
      </div>
      <ul class="my-pooq-noti-btn">
        <li @click.prevent="goLive">
          <a href="">
            <span class="icon-analysis icon-live">LIVE 시청하기</span>
            <span class="icon-analysis-btn"><NextButtonWhite/></span>
          </a>
        </li>
        <li @click.prevent="goVod">
          <a href="">
            <span class="icon-analysis icon-vod">VOD 시청하기</span>
            <span class="icon-analysis-btn"><NextButtonWhite/></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'

export default {
  components: {
    NextButtonWhite
  },
  props: {
    data: {
      type: Object
    },
    device: {
      type: String
    },
    isLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      typeImage: null,
      ready: false
    }
  },
  computed: {
    showThreeMonth () {
      if (!this.data) {
        return ''
      }
      let date = new Date()
      date.setMonth(date.getMonth() - 3)
      let joinDate = new Date(+this.data.joindate.substr(0, 4),
        (+this.data.joindate.substr(5, 2)) - 1, +this.data.joindate.substr(8, 2))
      return date > joinDate
    },
    hasData () {
      return (this.data && this.data.type) && this.ready
    }
  },
  methods: {
    goLive () {
      if (this.device === 'mobile') {
        this.$router.push('/live')
      } else {
        location.href = 'captvpooq://live/index'
      }
    },
    goVod () {
      if (this.device === 'mobile') {
        this.$router.push('/vod')
      } else {
        location.href = 'captvpooq://vod/index'
      }
    },
    fileNameType (type) {
      let filename = ''
      switch (type) {
        case '본방사수형':
          filename = 'ic-type-1.svg'
          break
        case '주말 몰아보기형':
          filename = 'ic-type-2.svg'
          break
        case '최신 VOD 바로보기형':
          filename = 'ic-type-3.svg'
          break
        case '영화 매니아형':
          filename = 'ic-type-4.svg'
          break
        case '느긋하게 다시보기형':
          filename = 'ic-type-5.svg'
          break
        case '종영작 정주행형':
          filename = 'ic-type-6.svg'
          break
        default:
          filename = 'ic-type-1.svg'
      }
      return filename
    }
  },
  beforeUpdate () {
    if (this.data.joindate) {
      this.ready = true
    }
    if (this.data.type && this.typeImage === null) {
      const fileName = this.fileNameType(this.data.type)
      this.typeImage = () => import(`@/assets/svg/common/watch-type/${fileName}`)
    }
  }
}
</script>

<style lang="css">
.no-pooq{
  padding: 62px 0;
  background-color: #252525;
}

.no-pooq p{
  font-size: 16px;
  line-height: 24px;
  color: #a5a5a5;
  text-align: center;
}

.no-pooq p > span{
  color: #fff;
}

/* 취향 분석 */
.my-type-top{
  margin-bottom: 10px;
  padding: 30px 40px;
  /*display: table;*/
  width: 100%;
  table-layout: fixed;
}

.my-type-ico{
  width: 102px;
  display: table-cell;
  vertical-align: middle;
}

.my-type-ico img{
  width: 100%;
}

.my-type-text-wrap{
  display: table-cell;
  width: calc(100% - 102px);
  padding-left: 19px;

  vertical-align: middle;
}

.my-type-tit{
  font-size: 16px;
  line-height: 24px;
  color: #a5a5a5;
}

.my-type-tit > span{
  display: block;
  color: #3887ff;
}

.my-type-text01{
  font-size: 12px;
  line-height: 16px;
  color: #a5a5a5;
  margin-top: 10px;
}
.icon-analysis:before{
  content: '';
  display: inline-block;
  vertical-align: middle;
  width: 41px;
  height: 40px;
  margin-right: 16px;
}
.icon-live:before{
  background: url(/img/mypooq/ico-live.png) no-repeat;
  -webkit-background-size: 41px 40px;
  background-size: 41px 40px;
}
.icon-vod:before{
  background: url(/img/mypooq/ico-vod.png) no-repeat;
  -webkit-background-size: 41px 40px;
  background-size: 41px 40px;
}
.icon-analysis-btn{
  margin-left: auto;
}

</style>
